import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type SupplierFerryDate = ResultOf<
  typeof supplierFerryDatesQuery
>["supplier"]["ferryDates"][number];

export const supplierFerryDatesQuery = graphql(`
  query SupplierFerryDates($id: ID!) {
    supplier(id: $id) {
      id
      ferryDates {
        id
        sailing_date
        created_at
      }
    }
  }
`);
